<template>
  <button
    v-if="types.length === 1 && !inputMode"
    @click="startAdding(types[0].type)"
    class="add-item action"
    :class="{ callToAction }"
  >
    {{ addText(types[0].type) }}
  </button>
  <button
    v-else-if="!active && !inputMode"
    @click="activate"
    class="add-item action"
    :class="{ callToAction }"
  >
    Dodaj...
  </button>
  <div v-else-if="!inputMode" class="add-item">
    <button v-for="t in types" @pointerdown.stop @click="startAdding(t.type)">
      <div class="md-icon">{{ t.icon }}</div>
      {{ TypeText(t.type) }}
    </button>
    <button
      v-if="!hintsShown.taskVsNote"
      class="md-icon short"
      @pointerdown.stop
      @click="typesHint"
    >
      help
    </button>
  </div>
  <div class="inputmlask" v-else>
    <div class="md-icon">{{ icon }}</div>
    <EditableDiv
      class="textinput"
      v-model="itemText"
      ref="itemInput"
      @keydown.enter.stop.prevent="create"
      @keydown.capture.esc="itemText = ''"
      @blur="clearIfEmpty"
    />
    <button @click="create" class="md-icon">add</button>
  </div>
</template>

<style scoped>
.add-item {
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: var(--min-button-height);
}

button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.add-item button {
  flex: 1 0 80px;
  min-height: var(--min-button-height);
}
button.md-icon.short {
  flex: 0 0 40px;
  color: var(--link-color);
}

.main-panel .callToAction {
  background-color: var(--cta-color);
  opacity: 100%;
}

.inputmlask {
  display: flex;
  gap: 8px;
  min-width: 280px;
}
.textinput {
  flex: auto;
  margin: 8px;
}
</style>

<script>
import {
  CONTAINER_TYPES,
  allowedChildInfo,
  ORDINARY_TYPES,
  typeIconMapping,
} from "@/structure";
import { getItem } from "@/reactive-cache";
import hintsShown from "@/hints";
import EditableDiv from "./EditableDiv.vue";

export default {
  name: "AddItem",
  props: ["targetID"],
  components: { EditableDiv },
  data() {
    return {
      active: false,
      inputMode: false,
      itemText: "",
      listener: null,
      hintsShown: hintsShown,
    };
  },
  computed: {
    target() {
      return getItem(this.targetID);
    },
    types() {
      return allowedChildInfo(this.target);
    },
    callToAction() {
      return (
        this.target.getChildren().length === 0 &&
        ![...ORDINARY_TYPES, "date"].includes(this.target.type)
      );
    },
    icon() {
      return typeIconMapping[this.itemType] || "";
    },
  },
  methods: {
    deactivate() {
      this.active = false;
      document.removeEventListener("pointerdown", this.deactivate);
    },
    activate() {
      this.active = true;
      document.addEventListener("pointerdown", this.deactivate);
    },
    startAdding(type) {
      this.inputMode = true;
      this.itemType = type;
      this.$nextTick(() => {
        this.$refs?.itemInput?.focus();
      });
    },
    create() {
      this.target.createItem(this.itemType, this.itemText);
      this.itemText = "";
    },
    clearIfEmpty() {
      if (!this.itemText) {
        this.inputMode = false;
      }
    },
    addItem(type) {
      this.target.createChild(type);
    },
    typesHint() {
      window.alert(
        "Zadanie - działanie, coś co może zostać wykonane lub nie\n" +
          "Notatka - dowolna informacja do zapamiętania",
      );
      hintsShown.taskVsNote = true;
    },
    addText(type) {
      switch (type) {
        case "list":
          return "Dodaj listę";
        case "task":
          return "Dodaj zadanie";
        case "note":
          return "Dodaj notatkę";
        case "period":
          return "Dodaj zakres czasu";
        case "label":
          return "Dodaj etykietę";
      }
    },
    TypeText(type) {
      switch (type) {
        case "list":
          return "lista";
        case "task":
          return "zadanie";
        case "note":
          return "notatka";
        case "period":
          return "zakres czasu";
        case "label":
          return "etykieta";
      }
    },
  },
};
</script>
